import urban from "../../assets/projects/urban-mL.jpg";
import x from "../../assets/projects/x.jpg";
import omdb from "../../assets/projects/imdb-quickfind.png";
import gh from "../../assets/projects/github-repo.png";
import notesy from "../../assets/projects/notesy.png";
import passgen from "../../assets/projects/passgen.jpg";
import ielts from "../../assets/projects/ielts.png";
import sms from "../../assets/projects/sms.png";
import fire from "../../assets/projects/fire.png";
import resize from "../../assets/projects/picresize.png";
import stroke from "../../assets/projects/strokepreds.png";



const Menu = [
  {
    title: "Enhance Bangladesh Urban Planning with Machine Learning",
    image: urban,
    githubUrl: "https://github.com/Khandaker-Atik/Urban-Development-Research-Projects",
    youtubeUrl: null,
    tags: ["ML", "Urban Planning", "Drone Imagery"],
    year: "2024",
    description: "Enhance urban planning in Bangladesh with 3D mapping and detection of infrastructure using drone images."
  },
  {
    title: "Twitter Hate Speech Detection",
    image: x,
    githubUrl: "https://github.com/Khandaker-Atik/",
    youtubeUrl: null,
    tags: ["CNN", "NLP", "ML"],
    year: "2023",
    description: "CNN-based contextual hate speech classification using Twitter data."
  },
  {
    title: "IMDB Quick Find",
    image: omdb,
    githubUrl: "https://github.com/Khandaker-Atik/imdb-quickfinder",
    youtubeUrl: "https://imdb-quickfinder.vercel.app/",
    tags: ["OMDb API", "Movie Search", "Web App"],
    year: "2025",
    description: "Minimalist movie search app powered by OMDb API, featuring clean UI and real-time results."
  },
  {
    title: "GitHub Repository Manager",
    image: gh,
    githubUrl: "https://github.com/Khandaker-Atik/github-repo-manager",
    youtubeUrl: "https://github-repo-manager-lemon.vercel.app/",
    tags: ["GitHub", "Web App", "Manager"],
    year: "2025",
    description: "List-style, folder-inspired interface for managing GitHub repositories."
  },
  {
    title: "InkFlare – Firebase Notes App",
    image: notesy,
    youtubeUrl: "https://inkflare-seven.vercel.app/",
    tags: ["Note Taking", "Firebase", "Web App"],
    year: "2025",
    description: "A cute, animated notes app with Firebase backend. Allows users to create, edit, delete, and download notes with a smooth and responsive UI."
  },
  {
    title: "AI Based Password Generator",
    image: passgen,
    githubUrl: "https://github.com/Khandaker-Atik/passgen",
    youtubeUrl: "https://passgen-ai.vercel.app",
    tags: ["Password", "Generator", "Web App"],
    year: "2023-(Last Update 2025)",
    description: "Secure random password generator with adjustable options and a clean UI."
  },
  {
    title: "IELTS from Bangladesh",
    image: ielts,
    githubUrl: "https://github.com/Khandaker-Atik/ielts-from-bd",
    youtubeUrl: "https://ielts-from-bd.vercel.app/",
    tags: ["IELTS", "Education", "Web App"],
    year: "2023-(Last Update 2025)",
    description: "Next.Js based comprehensive platform for IELTS preparation tailored for Bangladeshi students."
  },
  {
    title: "Advanced School Management System",
    image: sms,
    githubUrl: "https://github.com/Khandaker-Atik/sms",
    tags: ["CRUD", "Laravel"],
    year: "2023",
    description: "Comprehensive school and bookshop management system with advanced CRUD features."
  },
  {
    title: "Advanced Fire and Smoke Detection",
    image: fire,
    githubUrl: "https://github.com/Khandaker-Atik/CSE360",
    tags: ["Computer Interfacing", "Emergency Alert"],
    year: "2023",
    description: "Advanced Fire and smoke detection system built for interfacing and emergency alerting."
  },
  {
    title: "Picture Resizer Web App",
    image: resize,
    githubUrl: null,
    youtubeUrl: "https://photo-resizer-xi.vercel.app",
    tags: ["Flask", "Image Processing", "Web App"],
    year: "2024",
    description: "Image resizing tool built with Python Flask and deployed on Vercel."
  },
  {
    title: "Stroke Prediction AI",
    image: stroke,
    githubUrl: "https://github.com/Khandaker-Atik/AI-stroke-preds",
    tags: ["ML", "Health", "Prediction"],
    year: "2023",
    description: "ForeSight: ML-powered model to predict stroke risk using health-related indicators."
  }
];

export default Menu;
